import * as React from 'react';
import Button from '../../Button/Button';
import type { OnFilterChangeHandler } from '../types';
import cn from '~modules/cn';
import Styles from './filter-views.module.scss';
import CloseIcon from '../../../../assets/icons/v2design/basics/close.svg';

type Props = {
    onChange: OnFilterChangeHandler;
    className?: string;
};

const DeleteFilterButton = (props: Props) => (
    <Button
        className={cn(Styles['delete-filter-button'], props.className)}
        buttonType="tertiary"
        buttonSize="small"
        icon={<CloseIcon />}
        onClick={() => {
            props.onChange(null);
        }}
    />
);

export default DeleteFilterButton;
